import { GridSelectionModel } from '@mui/x-data-grid-pro';
import * as React from 'react';
import { ActionHandler } from '../../actions';
import { AddCredential } from './AddCredential';
import { Search } from './Search';
import { Selection } from './Selection';

interface Props {
  selection: GridSelectionModel;
  onAction: ActionHandler;
  onAddCredential: () => void;
}

export const ActionBar: React.FC<Props> = (props) => {
  return (
    <div className="flex space-x-6">
      <Selection selection={props.selection} onAction={props.onAction} />
      <Search />
      <AddCredential onClick={props.onAddCredential} />
    </div>
  );
};
ActionBar.displayName = 'ActionBar';
